document.addEventListener('DOMContentLoaded', function () {
  console.log('[MDS] script loaded');
  if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') {
    console.log('[MDS] subscribe or PUB_SUB_EVENTS not found');
    return;
  }

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    console.log('[MDS] variantChange fired', event.data);

    const { sectionId, variant } = event.data;
    if (!variant) {
      console.log('[MDS] no variant in event');
      return;
    }

    const dataScript = document.getElementById(`MaterialDescriptions-${sectionId}`);
    const descEl = document.getElementById(`Description-${sectionId}`);
    console.log('[MDS] dataScript found:', !!dataScript, 'descEl found:', !!descEl);
    if (!dataScript || !descEl) return;

    try {
      const map = JSON.parse(dataScript.textContent);
      console.log('[MDS] map keys:', Object.keys(map));
      console.log('[MDS] looking for variant.id:', variant.id, typeof variant.id);

      const html = map[variant.id];
      console.log('[MDS] found value:', html);

      if (typeof html === 'string') {
        descEl.innerHTML = html;
        console.log('[MDS] description updated successfully');
      }
    } catch (e) {
      console.error('[MDS] error:', e);
    }
  });
});